/**
 * Session hydrate / identity helpers (VAULT-37/38).
 * Overlapping onAuthStateChanged loads must not write the previous uid's
 * profile onto the next user — that crashed the vault and sent listing
 * back into the complete-profile wizard (MKT-37).
 */

export function isStaleSessionLoad({ cancelled, gen, currentGen, expectedUid, liveUid }) {
  if (cancelled) return true;
  if (gen !== currentGen) return true;
  if (expectedUid && liveUid && expectedUid !== liveUid) return true;
  return false;
}

export function isIdentitySwap(previousUid, nextUid) {
  return Boolean(previousUid && nextUid && previousUid !== nextUid);
}

/** Stale profile from a previous uid — do not treat as this user's completeness. */
export function profileBelongsToUser(profile, uid) {
  if (!profile || !uid) return false;
  const profileUid = profile.id || profile.uid;
  return !profileUid || profileUid === uid;
}
